import { render } from "./price_lists.html?vue&type=template&id=6f025a7e&scoped=true&external"
import script from "./price_lists.vue?vue&type=script&lang=js"
export * from "./price_lists.vue?vue&type=script&lang=js"

import "./price_lists.vue?vue&type=style&index=0&id=6f025a7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f025a7e"]])

export default __exports__